import { Typography } from "@material-tailwind/react";

export const getTranslatedWorkorderTypeLabel = (workorderType?: EasyTech.WorkorderType): string => {
  if (!workorderType) {
    return "-";
  }

  const currentLanguage = localStorage.getItem("i18nextLng") || "en";

  if (workorderType.translations && Array.isArray(workorderType.translations)) {
    const translation = workorderType.translations.find(
      (item) => item.language?.isoCode === currentLanguage
    );

    if (translation && translation.label) {
      return translation.label;
    }
  }

  return workorderType.label || "-";
};

/**
* WorkorderTypeDisplay: Display workorder type
* @param type - WorkorderType data
* @param size - Size options
*/
export default function WorkorderTypeDisplay({
  type,
  size = "md"
}: {
  type?: EasyTech.WorkorderType,
  size?: "sm" | "md" | "lg"
}) {
  if (!type || !type.label) {
    return <Typography variant="small" color="blue-gray">-</Typography>;
  }

  const textSize = size === "sm" ? "small" : size === "md" ? "small" : "paragraph";

  return (
    <Typography variant={textSize} color="blue-gray">
      {getTranslatedWorkorderTypeLabel(type)}
    </Typography>
  );
}
